module.exports = __webpack_public_path__ + "static/media/W18-0930_AW_Beyond-Meat_Mobile_Hero_767x845_fr.0e1c0e09.jpg";